import { useQuery } from '@tanstack/react-query';
import { getOfferingCategoryById } from '../api/offeringCategories';

export function useOfferingCategory(id: string | null) {
  return useQuery({
    queryKey: ['offering-categories', id],
    queryFn: () => (id ? getOfferingCategoryById(id) : null),
    enabled: id !== null,
  });
}
